import {ExceptionsClient} from "../client/ExceptionsClient";
import {fetchExceptionShipments} from "./ExceptionShipmentsAPI";
import {subtractDaysFromCurrentDate} from "../../util/CommonUtils"
import {getRegion} from "../../util/CommonUtils";
import {
    SCRUB_EXCEPTION_CATEGORIES,
    SCRUB_EXCEPTION_START_RANGE_DAYS,
    SCRUB_EXCEPTION_START_RANGE_DAYS_IN,
    SCRUB_EXCEPTION_END_RANGE_DAYS,
    SCRUB_EXCEPTION_END_RANGE_DAYS_IN,
    SCRUB_EXCEPTION_CATEGORIES_ON_ROAD,
    SCRUB_EXCEPTION_START_RANGE_DAYS_LOST,
    SCRUB_EXCEPTION_END_RANGE_DAYS_LOST,
    IS_LOST_TAB_ENABLED
} from "../constants/ScrubConstants";
import {REGION} from "../constants/CommonConstants";

export async function fetchScrubStats(params, dispatcher) {
    const startDaysForExceptionShipments = REGION.IN === getRegion() ? SCRUB_EXCEPTION_START_RANGE_DAYS_IN : SCRUB_EXCEPTION_START_RANGE_DAYS;
    const endDaysForExceptionShipment = REGION.IN === getRegion() ? SCRUB_EXCEPTION_END_RANGE_DAYS_IN : SCRUB_EXCEPTION_END_RANGE_DAYS;
    Promise.all([ExceptionsClient.getScrubStats({
        "targetUseCase": "MISSING",
        "metaData": {
            "includeMNR": "false"
        }
    }), ExceptionsClient.getScrubStats({
        "targetUseCase": "LOST"
    }), fetchExceptionShipments({
        "categories": SCRUB_EXCEPTION_CATEGORIES,
        "startDate": Math.floor(subtractDaysFromCurrentDate(startDaysForExceptionShipments).getTime()/1000),
        "endDate": Math.floor(subtractDaysFromCurrentDate(endDaysForExceptionShipment).getTime()/1000),
        "shipmentDetailsRequired": false,
        "targetStatus": "OPEN",
        "returnPaginationIndex": true,
        "targetUseCase" : "MISSING"
    }), fetchExceptionShipments({
        "categories":SCRUB_EXCEPTION_CATEGORIES_ON_ROAD,
        "startDate": Math.floor(subtractDaysFromCurrentDate(SCRUB_EXCEPTION_START_RANGE_DAYS_LOST).getTime()/1000),
        "endDate": Math.floor(subtractDaysFromCurrentDate(SCRUB_EXCEPTION_END_RANGE_DAYS_LOST).getTime()/1000),
        "shipmentDetailsRequired": false,
        "targetStatus": "OPEN",
        "returnPaginationIndex": true,
        "targetUseCase" : "LOST"
    })]).then(([missingResult, lostResult, exceptionShipmentsResult, lostExceptionShipmentResult]) => {
        if (missingResult.valid && lostResult.valid
            && exceptionShipmentsResult.valid && lostExceptionShipmentResult.valid) {

            var missingResultScannableIds = missingResult.data.scrubShipments;
            for (var exceptionShipment in exceptionShipmentsResult.data) {
                if (!missingResultScannableIds.includes(exceptionShipmentsResult.data[exceptionShipment].scannableId)) {
                    missingResultScannableIds.push(exceptionShipmentsResult.data[exceptionShipment].scannableId);
                }
            }
            //add SCRUB_EXCEPTION_CATEGORIES_ON_ROAD to lost queue
            var lostResultScannableIds = lostResult.data.scrubShipments;
            for (var lostExceptionShipment in lostExceptionShipmentResult.data) {
                if (!lostResultScannableIds.includes(lostExceptionShipmentResult.data[lostExceptionShipment].scannableId)) {
                    lostResultScannableIds.push(lostExceptionShipmentResult.data[lostExceptionShipment].scannableId);
                }
            }

            const computed = {
                "MISSING_COUNT": missingResultScannableIds.length,
                "LOST_COUNT": lostResultScannableIds.length
            };
            dispatcher({
                type: "SET_DATA",
                data: computed
            });
        }
    });
}

export function fetchLostTabStatus(setIsLostTabEnabled) {
    ExceptionsClient.getFeatureStatus({
        featureName : IS_LOST_TAB_ENABLED
    }).then(({valid, data}) => {
        if (valid && data.status) {
            setIsLostTabEnabled(true);
        }
    });
}




// WEBPACK FOOTER //
// ./src/commons/api/ScrubStatsAPI.js